export const MenuItems = [
    {
      title: 'Board of Directors',
      path: '/#',
      cName: 'dropdown-link'
    },
    {
      title: 'Senior Leadership',
      path: '/#',
      cName: 'dropdown-link'
    },
    {
      title: 'Junior Leadership',
      path: '/#',
      cName: 'dropdown-link'
    },
    {
      title: 'Key Partnership',
      path: '/#',
      cName: 'dropdown-link'
    },
    {
      title: 'Governmentals',
      path: '/#',
      cName: 'dropdown-link'
    },
    {
      title: 'Key Contractors',
      path: '/#',
      cName: 'dropdown-link'
    }
  ];